import './wdyr'
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './input.css'
import { AuthContextProvider } from "./context/authcontext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContextProvider>
      <App />
  </AuthContextProvider>
);


